import React, { useState, useEffect, useLayoutEffect } from 'react'
import Modal from 'react-modal'
import Loader from 'react-loader-spinner'
import PhoneInput from 'react-phone-number-input'
import * as EmailValidator from 'email-validator'
import htmlMail from './html-email'
import menuX from '../../images/menu-x.png'
import add from '../../images/add.svg'
import { db } from '../../firebase'

import 'react-phone-number-input/style.css'
import './index.css'

const ConnectModal = ({ isOpen, onRequestClose }) => {

  // state

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState (<div className="message-container"></div>)
  const [artists, setArtists] = useState([''])
  const [inputsToRender, setInputsToRender] = useState(1)

  // simplify to one artist input for mobile

  const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight])
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const [width, height] = useWindowSize()

  // effects

  useEffect(() => {
    if(!allFieldsComplete() || !emailIsValid()) setDisabled(true)
    else setDisabled(false)
    setMessage(<div className="message-container"></div>)
    console.log('HERE ARE THE ARTISTS: ', artists)
  }, [name, email, phone, artists])

  useEffect(() => {
    
  }, [success])

  // helpers & handlers

  const afterOpenModal = () => console.log('sign in modal opened')  

  const emailIsValid = () => EmailValidator.validate(email)

  const allFieldsComplete = () => !(name === '' || email === '' || phone === '' || artists === [''])

  const getArtists = () => {
    const artistsList = artists.map((artist, index) => {
      return ` artist${index + 1}: ${artist}`
    })
    return artistsList
  }

  const writeUserToDatabase = async () => {
    const res = await db.collection("users").add({
      name: name,
      email: email,
      phone: phone,
      artists: artists,
      time: Date.now()
    })
    .then(async (docRef) => {
      console.log("Document written", docRef.id);
      const emailRes = await db.collection("mail").add({
        to: ['concierge@createsafe.io'],
        message: {
          subject: 'CREATESAFE Services Evaluation',
          text: `email: ${email}, name: ${name}, phone: ${phone},${getArtists()}`
        }
      })
      .then(() => {
        return ({ status: 'success' })
      })
      .catch(error => {
        console.log('error writing email', error)
        return { status: 'error', error: error }
      })
      console.log(emailRes)
      return({ status: 'success' })
    })
    .catch(error => {
      console.error("Error adding document: ", error)
      return{ status: 'error', error: error }
    })
    console.log(res)
    return res
  }

  const handleContactClick = async() => {
    if(disabled === true) {
      if(!allFieldsComplete()) {
        setMessage(<div className="message-container">Please complete all fields</div>)
        return null
      }
      if(!emailIsValid()) setMessage(<div className="message-container">Please enter a valid email</div>)
      return null
    }
    setProcessing(true)
    const res = await writeUserToDatabase()
    console.log('HERE IS THE RES AFTER DATABASE WRITE: ',res)
    setProcessing(false)
    if(res.status === 'success') setSuccess(true)
    else setError(true)
    return
  }

  const handleChanges = (value, index) => {
    let artistsCopy = [...artists]
    artistsCopy[index] = value
    setArtists(artistsCopy)
  }

  const calculateInputs = () => {
    let newNumberOfInputs
    if(width < 454) return 1
    if(inputsToRender > 2) newNumberOfInputs = inputsToRender
      else newNumberOfInputs = inputsToRender + 1
    return newNumberOfInputs
  }

  const renderArtistInputs = () => {
    let artistInputs = []
    for(let i = 0; i < inputsToRender; i++) {
      artistInputs.push(
        <input type="text" name={`artist-input-${i}`} value={artists[i]} onChange={e => handleChanges(e.target.value, i)} placeholder="An artist you manage" />
      )
    }
    return artistInputs
  }

  const Processing = () => (  
    <Loader
      type="BallTriangle"
      color={"white"}
      height={40}
      width={40}
      timeout={30000} // 30 secs
    />
  )

  const Success = () => (  
    <div className="nova-bold eighteen">Success! We'll be in touch shortly</div>
  )

  const Error = () => (  
    <div className="nova-bold eighteen">Something went wrong... please try again later</div>
  )

  // conditional renders 

  const renderFormContent = () => {
    if(processing) return <Processing />
    if(success) return <Success />
    if(error) return <Error />
    return (
      <>
        <img src={menuX} onClick={onRequestClose} className="close-modal" />
        <div>
          <h1 className="uppercase" id="contact-heading">Sign Up for a Free Services Evaluation</h1>     
        </div>
        <div className="flex-center column full-width">
          <input type="text" name="name" value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
          <input type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" />        
            <PhoneInput
              placeholder="Enter phone number"
              value={phone}
              onChange={setPhone}
            />        
          {renderArtistInputs()}
          {width < 454 ? null : <img src={add} onClick={() => setInputsToRender(calculateInputs())} className="add-artist-button" /> }
        </div>
        <div className="full-width flex-center column" >
          <div className="button flex-center submit-button" onClick={handleContactClick}>
            <span>
              Submit
            </span>
          </div>
          {message}
        </div>
      </>
    )
  }

  // since we are using the window, only render if it exists

  if(typeof window === 'undefined') return null

  // main render

  return(
    <Modal
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={onRequestClose}
      closeTimeoutMS={500}
      className={"Modal"}
      id={"connect-modal"}
      overlayClassName="Overlay"
    >
      <div className="modal-content flex-center">
        {renderFormContent()}
      </div>
    </Modal>
  )
}

export default ConnectModal

